import EmployeeToggleDetails from "./EmployeeManagementToggle";

const allEmployeeRoutes = [
  {
    path: "employeemanagement",
    component: <EmployeeToggleDetails />,
  },
];

const EmployeeManagementRoute = {
  path: "employeemanagement",
  component: <EmployeeToggleDetails />,
};

export default allEmployeeRoutes;

export { EmployeeManagementRoute };
